"use strict";
/*
 * Created on 29/08/2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * FindWindowProductsParams
 *
 * @author Tomáš Leity
 */


var FindWindowProductsParams =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(FindWindowProductsParams, _DomainObject_1$Domai);

  /**
   * @param windowId
   * @param excludeIds
   */
  function FindWindowProductsParams(windowId) {
    var _this;

    var excludeIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : immutable_1.List.of();

    _classCallCheck(this, FindWindowProductsParams);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FindWindowProductsParams).call(this));
    _this.windowId = windowId;
    _this.excludeIds = excludeIds;
    return _this;
  }

  return FindWindowProductsParams;
}(DomainObject_1.DomainObject);

exports.FindWindowProductsParams = FindWindowProductsParams;